import React from "react";
import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";
import { RouteComponent, RouteComponentProps } from "react-router";

import { Spinner, SpinnerSize } from "@nuorder/components";
import { LAUNCH_DARKLY_ANONYMOUS_USER_KEY } from "constants/login";
import PageNotFound from "containers/page-not-found";

import { DATATEST } from "./constants";
import { useStyles } from "./feature-flagged.styles";

type FeatureFlaggedComponentProps = RouteComponentProps<any, any> & {
    flag: string;
    fallbackComponent?: RouteComponent;
    component: RouteComponent;
};

export const FeatureFlaggedComponent = ({
    flag,
    component: Component,
    fallbackComponent: FallbackComponent,
    ...props
}: FeatureFlaggedComponentProps) => {
    const styles = useStyles();

    const flags = useFlags();
    const clientLD = useLDClient();
    const contextLD = clientLD.getContext();
    const isLDKeyAnonymousUser = contextLD.key === LAUNCH_DARKLY_ANONYMOUS_USER_KEY;

    if (isLDKeyAnonymousUser) {
        return (
            <div className={styles.spinner} data-test={DATATEST.ROOT}>
                <Spinner size={SpinnerSize.large} />
            </div>
        );
    }

    if (!isLDKeyAnonymousUser && !flags[flag]) {
        if (FallbackComponent) {
            return <FallbackComponent {...props} />;
        } else {
            return <PageNotFound />;
        }
    }

    return <Component {...props} />;
};
